export default __webpack_public_path__ + "static/media/conceirgeBackgrond.893df15f.svg";